export default __webpack_public_path__ + "static/media/more_vert-black.f2acbf2e.svg";